import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { configAPI } from '../../services/(adminapi)/configAPI'

// Async thunks
export const fetchConfig = createAsyncThunk(
  'config/fetchConfig',
  async (_, { rejectWithValue }) => {
    try {
      const response = await configAPI.getConfig()
      return response.data
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue(null) // No config found, not an error
      }
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch configuration')
    }
  }
)

export const createOrUpdateConfig = createAsyncThunk(
  'config/createOrUpdateConfig',
  async (configData, { rejectWithValue }) => {
    try {
      const response = await configAPI.createOrUpdateConfig(configData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to save configuration')
    }
  }
)

const initialState = {
  config: null,
  loading: false,
  saving: false,
  error: null,
  success: null
}

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch config
      .addCase(fetchConfig.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.loading = false
        if (action.payload.success) {
          state.config = action.payload.data
        }
        state.error = null
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.loading = false
        if (action.payload === null) {
          // 404 - no config found, not an error
          state.config = null
          state.error = null
        } else {
          state.error = action.payload
        }
      })
      
      // Create or update config
      .addCase(createOrUpdateConfig.pending, (state) => {
        state.saving = true
        state.error = null
        state.success = null
      })
      .addCase(createOrUpdateConfig.fulfilled, (state, action) => {
        state.saving = false
        if (action.payload.success) {
          state.config = action.payload.data
          state.success = 'Configuration saved successfully!'
        }
        state.error = null
      })
      .addCase(createOrUpdateConfig.rejected, (state, action) => {
        state.saving = false
        state.error = action.payload
      })
  }
})

export const { clearError, clearSuccess } = configSlice.actions
export default configSlice.reducer

